import React, { useState } from "react";
import { Alert, Box, Snackbar } from "@mui/material";
import dayjs from "dayjs";
import { useUserData } from "components/customHooks/userDataContext";
import { handleExportExcel } from "./helper";
import useDictationSummary from "./useDictationSummary";
import DictationSummaryToolbar from "./dictationSummaryToolbar";
import DictationSummaryGrid from "./dictationSummaryGrid";

const DictationSummary = ({ dateOfService, isDialog = false, npi }) => {
  const [dos, setDos] = useState(dayjs());
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const userData = useUserData();
  const token = userData?.access_token;

  const summary = useDictationSummary({
    userData,
    token,
    dateOfService,
    dos,
    setSnackbar,
    npi,
  });

  return (
    <Box p={2} bgcolor="white">
      <DictationSummaryToolbar
        isDialog={isDialog}
        dos={dos}
        setDos={setDos}
        loading={summary.loading}
        selectedRowIds={summary.selectedRowIds}
        updateSelectedDictations={summary.updateSelectedDictations}
        bulkFields={summary.bulkFields}
        bulkValue={summary.bulkValue}
        selectedBulkType={summary.selectedBulkType}
        bulkValueOptions={summary.bulkValueOptions}
        handleBulkFieldChange={summary.handleBulkFieldChange}
        setBulkValue={summary.setBulkValue}
        handleBulkUpdate={summary.handleBulkUpdate}
        handleClearSelection={summary.handleClearSelection}
        handleIgnoreAll={summary.handleIgnoreAll}
        handleUndoIgnore={summary.handleUndoIgnore}
        handleExport={() =>
          handleExportExcel({
            data: summary.data,
            setSnackbar,
            dateOfService,
            dos,
            practiceUsers: summary.practiceUsers,
          })
        }
      />

      <DictationSummaryGrid
        data={summary.data}
        loading={summary.loading}
        selectedRowIds={summary.selectedRowIds}
        setSelectedRowIds={summary.setSelectedRowIds}
        practiceUsers={summary.practiceUsers}
        isDialog={isDialog}
        updateSelectedDictations={summary.updateSelectedDictations}
        updateErrorFields={summary.updateErrorFields}
        updateAssignedUser={summary.updateAssignedUser}
      />

      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert severity={snackbar.severity}>{snackbar.message}</Alert>
      </Snackbar>
    </Box>
  );
};

export default DictationSummary;
